import { Component, ElementRef, NgZone, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { CorpAuthorityFormComponent } from './corp-authority-form/corp-authority-form.component';
import { DirectoryInfoFormComponent } from './directory-info-form/directory-info-form.component';
import { SelectInputComponent, TextInputComponent, DateInputComponent, SelectOption, RadioComponent, PhoneMaskDirective } from 'ddmo-storybook-lib';
import { SharedService } from '../../../../shared/services/shared.service';
import { LABELS } from '../../../../shared/constants/lables.constants';
import { DocumentCategory, DocumentSubCategory } from '../../../../shared/constants/document.constants';
import { catchError, EMPTY, finalize, map, Observable, of, Subscription, switchMap, tap, throwError } from 'rxjs';
import { LoaderService } from '../../../../shared/services/loader.service';
import $ from 'jquery';
import { W9AlertComponent } from '../../../popups/processing/processing.component';
import { MatDialog } from '@angular/material/dialog';
import { PopupComponent } from '../popup/popup.component';
import { DentalCredentialsService } from '../../services/dental-credentials.service';
import { CreateTinComponent } from './create-tin/create-tin.component';
@Component({
    selector: 'app-add-location',
    imports: [CommonModule, ReactiveFormsModule, FormsModule, PhoneMaskDirective, CorpAuthorityFormComponent, DirectoryInfoFormComponent,
        SelectInputComponent, TextInputComponent, DateInputComponent, RadioComponent, CreateTinComponent],
    templateUrl: './add-location.component.html',
    styleUrl: './add-location.component.scss'
})
export class AddLocationComponent {

    public primaryLocationFormGroup = this.formBuilder.group({
        isPrimary: new FormControl(''),
    });

    public practiceFormGroup = this.formBuilder.group({
        isPracticing: new FormControl(''),
    });

    public participatingFormGroup = this.formBuilder.group({
        isParticipating: new FormControl('yes'),
    });
    public ServiceCheckForm = this.formBuilder.group({
        serviceLocationChecked: [false]
    })
    stateOptions: SelectOption[] = [
        { value: 'MO', viewValue: 'Missouri' },
        { value: 'SC', viewValue: 'South Carolina' }
    ]
    PHONE_PATTERN = LABELS.PHONE_PATTERN;
    EMAIL_PATTERN = LABELS.EMAIL_PTTERN;
    today: any = new Date();
    customErrorMessagesSsn = { minlength: LABELS.ERROR_MESSAGES.minimumNineCharecter, required: 'Required' };
    customErrorMessagesZip = { minlength: LABELS.ERROR_MESSAGES.minimumFiveCharecter, required: 'Required' };
    customErrorMaxLength = { maxlength: LABELS.ERROR_MESSAGES.maxName, required: 'Required' };
    customErrorCity = { maxlength: LABELS.ERROR_MESSAGES.maxCity, required: 'Required' }
    errormessages = LABELS.ERROR_MESSAGES
    FIELD_LIMITS = {
        tin: { type: 'string', maxLength: 9 },
        name: { type: 'string', maxLength: 80 },
        address: { type: 'string', maxLength: 55 },
        city: { type: 'string', maxLength: 50 },
        state: { type: 'string', maxLength: 2 },
        zip: { type: 'string', maxLength: 5 },
        voicePhone: { type: 'string', maxLength: 14 },
        email: { type: 'string', maxLength: 255 }
    }
    public locationFormGroup = new FormGroup({
        tin: new FormControl('', [Validators.required, Validators.minLength(9), Validators.maxLength(9)]),
        name: new FormControl('', [Validators.required, Validators.maxLength(80)]),
        location: new FormControl('', [Validators.required, Validators.maxLength(55)]),
        city: new FormControl('', [Validators.required, Validators.maxLength(50)]),
        state: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(2)]),
        zip: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]),
        startDate: new FormControl<Date | string>('', [Validators.required, this.startDateAfterOrOnTinEffectiveDateValidator.bind(this)]),
        endDate: new FormControl<Date | string>(''),
        officeTypeID: new FormControl('', [Validators.required]),
        voicePhone: new FormControl('', [Validators.required, Validators.pattern(this.PHONE_PATTERN)]),
        email: new FormControl('', [Validators.required, Validators.pattern(this.EMAIL_PATTERN)])
    });
    officeTypeIDOptions: any[] = [
        { value: 155, viewValue: 'Clinic' },
        { value: 150, viewValue: 'Private practice' },
        { value: 153, viewValue: 'Hospital' },
        { value: 151, viewValue: 'Group practice' },
        { value: 156, viewValue: 'DSO' }
    ];
    directoryInfoSigned = false;
    corporateAuthSigned = false;
    showCorpAuthPopup = false;
    showDirectoryInfoPopup = false;
    locations: any;
    editLocationId: any = null;
    selectedItem: any;
    isPar: any = null;
    isWhLocation: boolean = false;
    directoryData: any;
    directoryArray: any = [];
    documents: any = [];
    documentsMap: any;
    dataToCorpForm: any;
    documentId: any = null;
    buttonText: string = 'Add location'
    isDocChanges: boolean = false;
    isW9Required: boolean = true;
    isSubmitTriggered: boolean = false;
    hasPrimaryLocation: boolean = false;
    primaryLocationId: any = null;
    showIsprimaryError: boolean = false;
    impersonatedUser: any = localStorage.getItem("impersonatedUser") ?? ""
    minDate = new Date(
        new Date().getFullYear() - 2,
        new Date().getMonth(),
        new Date().getDate()
    );
    suggestionCount: any = 0;
    private scrollHandler = this.onScroll.bind(this);
    selectedAddress: any = '';
    showFulladdressError = false
    isPlaceSelected: boolean = false;
    showError: boolean = false;
    isLocationFromTinSearch = false
    registeredState: any;
    allowedStates = ['MO', 'SC'];
    showStateError: boolean = false
    selectedLocationRecordFromTinSearch: any = null;
    isExistingTIN: boolean = false;
    isNewTIN: boolean = false
    isExistingTINNewLocationFlow: boolean = false;
    showTinAndPayeeSectionsForEdit: boolean = false;
    lockTinFieldsOnEdit: boolean = false;
    disableLocationNameForExistingTinFlow: boolean = false;
    private existingPrimaryLocationRef: any = null;
    private readonly DIRECTORY_INFO_SIGNED_KEY = 'directoryInfoSigned';
    private readonly PENDING_LOCATION_DIRECTORY_DATA_KEY = 'pendingLocationDirectoryData';
    private readonly locationFieldLockControls = ['tin', 'name', 'location', 'city', 'state', 'zip', 'officeTypeID', 'voicePhone', 'email'];
    get showTinAndPayeeSections(): boolean {
        return (this.isNewTIN || this.isLocationFromTinSearch || this.isExistingTINNewLocationFlow || this.showTinAndPayeeSectionsForEdit);
    }
    get showDateStartedField(): boolean {
        return !this.isWhLocation || this.isLocationFromTinSearch;
    }
    @ViewChild(CreateTinComponent) createTinComponent?: CreateTinComponent;
    @ViewChildren('locationInput') locationInputs!: QueryList<ElementRef>;
    private tinEffectiveDateValidationSubscription?: Subscription;
    isChangesmadeAfterCorpAuthSigned: boolean = false;
    beforeCorpAuthSignedData: any = null;
      VALIDATION_MESSAGES: any = {
        startDate: {
          required: 'Required',
          matDatepickerParse: 'Enter a valid date',
          matDatepickerMin: 'Date started date cannot be older than 2 years.',
          minDate: 'Date started date cannot be older than 2 years.',
          pattern: 'Enter a valid date',
          startDateAfterOrOnTinEffectiveDate: 'Date started must be on or after the TIN effective date.'
        }
      }
    get createTinLocationMeta() {
        return {
            isPrimary: this.primaryLocationFormGroup.get('isPrimary')?.value,
            isParticipating: this.participatingFormGroup.get('isParticipating')?.value,
            isPracticing: this.practiceFormGroup.get('isPracticing')?.value,
            isLocationFromTinSearch: this.isLocationFromTinSearch,
            isExistingTinNewLocationFlow: this.isExistingTINNewLocationFlow || !!this.selectedItem?.isExistingTinNewLocationFlow,
            isLocationEditMode: !!this.editLocationId,
            isMergedLocationEditMode: this.showTinAndPayeeSectionsForEdit,
            isDwLocationEditMode: !!this.selectedItem?.esLocationId && !this.selectedItem?.isLocationFromTINSearch,
            lockTinFieldsOnEdit: this.lockTinFieldsOnEdit,
            locationId: this.editLocationId ? (this.selectedItem?.locationId ?? null) : null,
            esLocationId: this.editLocationId ? (this.selectedItem?.esLocationId ?? null) : null,
            locationLookupId: this.editLocationId ?? null,
            dcaDocumentId: this.documentId,
            corpAuthSignedData: this.beforeCorpAuthSignedData ?? null,
            isDirectoryInfoCompleted: this.directoryInfoSigned || !!this.directoryData,
            directoryData: this.directoryData ?? null,
            isCorpAuthRequired: this.isCorpAuthRequierd()
        };
    }

    constructor(private router: Router, private formBuilder: FormBuilder, private service: SharedService,
        private datePipe: DatePipe, private sharedService: SharedService, private loader: LoaderService, private ngZone: NgZone,
        public dialog: MatDialog, private dentalCredentialingService: DentalCredentialsService,) { }

    ngOnInit() {
        $('.pac-container').remove();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const userDetails = JSON.parse(localStorage.getItem('loggedUserDetails') || '{}');
        this.registeredState = userDetails?.licenseState;
        if (this.registeredState === 'MO' || this.registeredState === 'SC') {
            this.allowedStates = [this.registeredState];
        } else {
            this.allowedStates = ['MO', 'SC'];
        }
        const selectedLocationRecordRaw = sessionStorage.getItem("selectedLocationRecord")
        const selectedLocationRecord = selectedLocationRecordRaw ? JSON.parse(selectedLocationRecordRaw) : null;
        const isNewLocationTIN = sessionStorage.getItem("isNewLocationTIN");
        this.editLocationId = localStorage.getItem('editLocationId');
        const isNewTinFlow = localStorage.getItem('isnewTIN') === 'true';
        const searchedTIN = localStorage.getItem("SearchedTin") ? localStorage.getItem("SearchedTin") : (isNewLocationTIN || "")
        const normalizedSearchedTin = `${searchedTIN || ''}`.trim();
        const searchTinResponse = JSON.parse(localStorage.getItem('SearchTINResponse') || '[]');
        const hasMatchingSearchRecord = normalizedSearchedTin
            ? (Array.isArray(searchTinResponse) ? searchTinResponse.some((item: any) => `${item?.taxId || item?.tin || ''}`.trim() === normalizedSearchedTin) : false)
            : false;
        const storedTaxEntityTin = `${localStorage.getItem('SearchTINTaxEntityTin') || ''}`.trim();
        const hasStoredTaxEntityForTin = !!normalizedSearchedTin && storedTaxEntityTin === normalizedSearchedTin;
        const hasSearchContextForTin = !!normalizedSearchedTin &&
            (hasMatchingSearchRecord || localStorage.getItem('SearchTinHasEntity') === 'true' || hasStoredTaxEntityForTin);
        this.isExistingTINNewLocationFlow = !this.editLocationId && !selectedLocationRecord && !isNewTinFlow &&
            (!!isNewLocationTIN || hasSearchContextForTin);
        if (!this.editLocationId && selectedLocationRecord) {
            const selectedLRecord = selectedLocationRecord
            this.selectedItem = selectedLRecord;
            this.selectedLocationRecordFromTinSearch = selectedLRecord
            this.isLocationFromTinSearch = true
            this.buttonText = 'Save location'
            if (selectedLRecord?.isParticipating === null || selectedLRecord?.isParticipating === undefined) {
                selectedLRecord.isParticipating = true;
            }
            this.setParticipating(selectedLRecord)
            this.bindFormData(selectedLRecord)
            this.onParticpatingChange()
        }
        if (!this.editLocationId && !selectedLocationRecord && !(localStorage.getItem("locationValueFromTINSave"))
            && !isNewTinFlow
            && searchedTIN) {
            this.locationFormGroup.patchValue({
                'tin': searchedTIN
            })
            this.locationFormGroup.get('tin')?.disable()
            this.applyDwLocationNameFromSearchList();
            if (this.isExistingTINNewLocationFlow) {
                this.locationFormGroup.get('name')?.disable();
            }
        } else if (localStorage.getItem("locationValueFromTINSave")) {
            const locationValueFromTINSave = localStorage.getItem("locationValueFromTINSave")
            if (!selectedLocationRecord && locationValueFromTINSave) {
                const locationFormValues = JSON.parse(locationValueFromTINSave)
                this.locationFormGroup.patchValue({
                    tin: locationFormValues.taxId ? locationFormValues.taxId : locationFormValues.tin,
                    name: locationFormValues.payeeName,
                    location: locationFormValues.payeeAddressLine1,
                    city: locationFormValues.payeeCity,
                    state: locationFormValues.payeeState,
                    zip: locationFormValues.payeeZip,
                })
                this.disableForm()
            }
        } else if (!selectedLocationRecord && localStorage.getItem("TINValueFromTINSave")) {
            const TINValueFromTINSave = localStorage.getItem("TINValueFromTINSave")
            this.locationFormGroup.patchValue({
                'tin': TINValueFromTINSave
            })
            this.locationFormGroup.get('tin')?.disable()
        } else if (isNewTinFlow) {
            this.isNewTIN = true
            this.locationFormGroup.patchValue({
                'tin': searchedTIN
            })
            this.locationFormGroup.get('tin')?.disable()
            const draftLocationRecords = JSON.parse(localStorage.getItem('LocationSavePayload') || '{}');
            if (draftLocationRecords && draftLocationRecords.length > 0) {
                const latestLocationrecord = draftLocationRecords.filter((location: any) => location.locationId == null)
                this.bindFormData(latestLocationrecord[0])
                if (latestLocationrecord[0].serviceLocationChecked && latestLocationrecord[0].serviceLocationChecked == true) {
                    this.ServiceCheckForm.patchValue({
                        'serviceLocationChecked': true
                    })
                }
            }
        }
        if (this.isExistingTINNewLocationFlow) {
            this.buttonText = 'Save location'
        }
        const storedLocations = localStorage.getItem('locations');
        const whLocations = JSON.parse((localStorage.getItem('whLocations') || '[]'));
        this.locations = storedLocations ? JSON.parse(storedLocations) : [];
        let directoryqns = localStorage.getItem('locationDirectories')
        this.directoryArray = directoryqns ? JSON.parse(directoryqns) : []
        if (this.editLocationId) {
            this.buttonText = 'Save location'
            this.selectedItem = this.locations.find(
                (location: any) => location.locationId == this.editLocationId || location.esLocationId == this.editLocationId
            );
            if (!this.selectedItem && selectedLocationRecord) {
                this.selectedItem = selectedLocationRecord;
            }
            if (!this.selectedItem) {
                this.selectedItem = whLocations.find((location: any) => location.esLocationId == this.editLocationId);
            }
            if (!this.selectedItem) {
                this.selectedItem = {};
            }
            const tinDetails = JSON.parse(localStorage.getItem('TINDetails') || '[]');
            const selectedTin = `${this.selectedItem?.tin ?? this.selectedItem?.taxId ?? ''}`;
            const matchedTinDetail = tinDetails.find((item: any) =>
                this.isSameTinIdentifier(item?.taxId ?? item?.tin, selectedTin)
            );
            const isNewlyAddedLocation = !this.selectedItem?.esLocationId;
            const isDwLocation = !!this.selectedItem?.esLocationId && !this.selectedItem?.isLocationFromTINSearch;
            this.showTinAndPayeeSectionsForEdit = isNewlyAddedLocation || isDwLocation;
            // Only the earliest-created location for a TIN keeps tax fields editable; later ones stay locked.
            const sameTinLocations = [...this.locations, ...whLocations].filter((location: any) => {
                const locationTin = `${location?.tin ?? location?.taxId ?? ''}`;
                return !!selectedTin && this.isSameTinIdentifier(locationTin, selectedTin);
            });
            const earliestLocationForTin = sameTinLocations.reduce((earliest: any, location: any) => {
                if (!earliest) return location;
                if (location?.esLocationId && !earliest?.esLocationId) return location;
                if (earliest?.esLocationId) return earliest;
                return Number(location?.locationId) < Number(earliest?.locationId) ? location : earliest;
            }, null);
            const isSelectedItemEarliest =
                !!earliestLocationForTin &&
                (
                    (!!this.selectedItem?.locationId && `${earliestLocationForTin.locationId}` === `${this.selectedItem.locationId}`) ||
                    (!!this.selectedItem?.esLocationId && `${earliestLocationForTin.esLocationId}` === `${this.selectedItem.esLocationId}`)
                );
            const hasPriorLocationForTin = !!selectedTin && !!earliestLocationForTin && !isSelectedItemEarliest;
            const storedLocationFieldState = this.getStoredLocationFieldLockState(this.selectedItem);
            const hasSavedNameLock = !!storedLocationFieldState?.['name'];
            const isTinFromDw = this.isTrueLikeValue(this.getFirstNonEmptyLocationValue(matchedTinDetail, ['isTinFromDW', 'IsTinFromDW']));
            const inferredExistingTinNewLocationFlow =
                isNewlyAddedLocation &&
                !this.selectedItem?.isLocationFromTINSearch &&
                isTinFromDw;
            if (inferredExistingTinNewLocationFlow && !this.selectedItem?.isExistingTinNewLocationFlow) {
                this.selectedItem = {
                    ...this.selectedItem,
                    isExistingTinNewLocationFlow: true
                };
            }
            const shouldLockNameForExistingTinFlow =
                !!this.selectedItem?.isExistingTinNewLocationFlow ||
                (
                    this.showTinAndPayeeSectionsForEdit &&
                    !!matchedTinDetail &&
                    !this.selectedItem?.isLocationFromTINSearch &&
                    isNewlyAddedLocation &&
                    isTinFromDw
                );
            this.disableLocationNameForExistingTinFlow =
                hasSavedNameLock ||
                shouldLockNameForExistingTinFlow ||
                (
                    this.showTinAndPayeeSectionsForEdit &&
                    !!matchedTinDetail &&
                    !this.selectedItem?.isLocationFromTINSearch &&
                    hasPriorLocationForTin
                );
            this.lockTinFieldsOnEdit = this.disableLocationNameForExistingTinFlow || isTinFromDw;
            this.documentId = this.selectedItem?.dcaDocumentId ? this.selectedItem.dcaDocumentId : null;
            this.isLocationFromTinSearch = this.selectedItem?.isLocationFromTINSearch ?? !!selectedLocationRecord?.isLocationFromTINSearch;
            this.isWhLocation = (!this.isLocationFromTinSearch && this.selectedItem.esLocationId) ? true : (this.isLocationFromTinSearch && this.selectedItem.esLocationId) ? true : false;
            if (this.isWhLocation || this.isLocationFromTinSearch) { this.setParticipating(this.selectedItem) }
            this.bindFormData(this.selectedItem);
            if (this.disableLocationNameForExistingTinFlow) {
                this.locationFormGroup.get('name')?.disable();
            }
            this.onParticpatingChange()
        }
        this.onParticpatingChange()
        this.getDocuments();
        /*if (this.isWhLocation || this.corporateAuthSigned || this.isLocationFromTinSearch) {
            this.disableForm();
        }*/
        if (this.isWhLocation) {
            this.disableForm();
        }
        else {
            this.locationFormGroup.get('tin')?.disable()
        }

        this.syncExistingPrimaryLocationState();
        if (this.hasPrimaryLocation) {
            if (this.editLocationId) {
                if (this.selectedItem.isPrimary == null || this.selectedItem.isPrimary == undefined) {
                    this.primaryLocationFormGroup.get('isPrimary')?.setValue('no');
                }
            } else {
                this.primaryLocationFormGroup.get('isPrimary')?.setValue('no');
            }
        } else {
            this.primaryLocationFormGroup.get('isPrimary')?.setValue('no');
        }
        if (this.impersonatedUser) {
            this.locationFormGroup.disable();
            this.primaryLocationFormGroup.disable();
            this.participatingFormGroup.disable();
            this.practiceFormGroup.disable();
        }
        this.syncStartDateRequiredValidation();
        this.participatingFormGroup.get('isParticipating')?.valueChanges.subscribe(async (value) => {
            const ctrl = this.primaryLocationFormGroup.get('isPrimary') as FormControl;
            if (value == 'no') {
                ctrl?.setValidators([Validators.required]);
            } else if (value == 'yes') {
                ctrl?.clearValidators();
                ctrl?.clearAsyncValidators();
                ctrl?.setErrors(null);
            }
            ctrl?.updateValueAndValidity();
        })
    }
    onParticpatingChange() {
        if (this.participatingFormGroup.get("isParticipating")?.value == 'yes') {
            this.isW9Required = true;
            this.primaryLocationFormGroup.get("isPrimary")?.enable()
        } else {
                this.primaryLocationFormGroup.get("isPrimary")?.setValue('no')
                this.isW9Required = !this.getTinHasParticipatingLocation() ? false : true;
                this.primaryLocationFormGroup.get("isPrimary")?.disable()
        }
        this.syncStartDateRequiredValidation();
    }

    private syncStartDateRequiredValidation() {
        const startDateControl = this.locationFormGroup.get('startDate');
        if (!startDateControl) {
            return;
        }
        if (this.showDateStartedField) {
            startDateControl.addValidators(Validators.required);
        } else {
            startDateControl.removeValidators(Validators.required);
        }
        startDateControl.updateValueAndValidity();
    }

    private applyDwLocationNameFromSearchList() {
        const normalizeLocationName = (value: any) => `${value || ''}`.replace(/[-\s]*\d{3}\s*$/, '').trim();
        const searchedTin = `${localStorage.getItem('SearchedTin') || sessionStorage.getItem('isNewLocationTIN') || ''}`.trim();
        if (!searchedTin) {
            return;
        }

        const searchTinResponse = JSON.parse(localStorage.getItem('SearchTINResponse') || '[]');
        const storedTaxEntityTin = `${localStorage.getItem('SearchTINTaxEntityTin') || ''}`.trim();
        const storedTaxEntityDetails = JSON.parse(localStorage.getItem('SearchTINTaxEntityDetails') || '{}');
        const dwMatch = Array.isArray(searchTinResponse)
            ? searchTinResponse.find((item: any) =>
                this.isSameTinIdentifier(item?.taxId ?? item?.tin, searchedTin)
            )
            : null;

        const dwName = normalizeLocationName(dwMatch?.name);

        const locationsInSession = JSON.parse(localStorage.getItem('locations') || '[]');
        const sessionMatch = Array.isArray(locationsInSession)
            ? locationsInSession.find((loc: any) =>
                this.isSameTinIdentifier(loc?.tin ?? loc?.taxId, searchedTin)
            )
            : null;
        const sessionName = normalizeLocationName(sessionMatch?.name);
        const taxEntityName = (storedTaxEntityTin === searchedTin && storedTaxEntityDetails)
            ? normalizeLocationName(storedTaxEntityDetails?.taxEntityName || storedTaxEntityDetails?.name)
            : '';

        const resolvedName = dwName || sessionName || taxEntityName;
        if (!resolvedName) {
            return;
        }

        this.locationFormGroup.patchValue({ name: resolvedName });
    }

    bindFormData(location: any) {
        this.locationFormGroup.patchValue({
            tin: location.taxId ? location.taxId : location.tin,
            name: location.name,
            location: location.address1 ? location.address1 : location.address ? location.address : "",
            city: location.city,
            state: location.state,
            zip: location.zip,
            startDate: location?.startPracticingAt ? new Date(this.sharedService.formatDate(location.startPracticingAt)) : "",
            endDate: location?.endedPracticingAt ? new Date(this.sharedService.formatDate(location.endedPracticingAt)) : "",
            officeTypeID: location.officeTypeID ?? location?.officeTypeId ?? null,
            voicePhone: location.voicePhone ?? null,
            email: !this.isEmptyLocationFieldValue(location?.locationEmail)
                ? location.locationEmail
                : (location?.email ?? '')
        })
        this.isLocationFromTinSearch = location.isLocationFromTINSearch ? location.isLocationFromTINSearch : this.isLocationFromTinSearch
        this.primaryLocationFormGroup.setValue({
            isPrimary: location.isPrimary == true ? 'yes' : (location.isPrimary == false || (this.isLocationFromTinSearch && !location.isPrimary)) ? 'no' : ''
        })
        this.locationFormGroup.updateValueAndValidity();
        if (this.isLocationFromTinSearch && !this.isPar) {
            this.primaryLocationFormGroup.get('isPrimary')?.disable()
        }
        if (this.isPar) {
            if (location.stillPracticing === null || location.stillPracticing === undefined || location.stillPracticing === '') {
                this.practiceFormGroup.setValue({
                    isPracticing: 'yes'
                })

            } else {
                this.practiceFormGroup.setValue({
                    isPracticing: location.stillPracticing === true ? 'yes' : location.stillPracticing === false ? 'no' : ''
                })
                if (location.stillPracticing === false) {
                    this.primaryLocationFormGroup.get('isPrimary')?.setValue('no');
                    this.primaryLocationFormGroup.get('isPrimary')?.disable();
                }
            }

            if (this.isWhLocation) {
                this.participatingFormGroup.setValue({
                    isParticipating: 'yes'
                })
                if (this.practiceFormGroup.get('isPracticing')?.value === 'no') {
                    this.isW9Required = !this.getTinHasParticipatingLocation() ? false : true;
                    this.locationFormGroup.get('startDate')?.enable();
                    this.locationFormGroup.get('endDate')?.setValidators([Validators.required]);
                    this.primaryLocationFormGroup.get('isPrimary')?.setValue('no');
                    this.primaryLocationFormGroup.get('isPrimary')?.disable();
                }
            } else {
                const ctrl = this.primaryLocationFormGroup.get('isPrimary') as FormControl;
                ctrl?.clearValidators();
                ctrl?.setErrors(null);
                ctrl?.updateValueAndValidity();
            }
        } else {
            const ctrl = this.primaryLocationFormGroup.get('isPrimary') as FormControl;
            ctrl?.clearValidators();
            ctrl?.clearAsyncValidators();
            ctrl?.setErrors(null);
            ctrl?.updateValueAndValidity();
        }
        this.participatingFormGroup.setValue({
            isParticipating: location.isParticipating === true
                ? 'yes'
                : location.isParticipating === false
                    ? 'no'
                    : (this.isLocationFromTinSearch ? 'yes' : '')
        })
        this.isW9Required = !this.getTinHasParticipatingLocation() ? false : true;
        if (location && location.esLocationId) {
            Object.keys(this.locationFormGroup.controls).forEach(key => {
                const control = this.locationFormGroup.get(key);
                if (key != "endDate" && control?.value) {
                    control.disable();
                }
            });
            if (this.isMergedDwLocationEdit(location)) {
                this.applyMergedDwLocationFieldState(location);
            } else if (location.isLocationFromTINSearch || location.isLocationFromTINSearch == null) {
                // phone/email stay locked when DW supplied a value, otherwise the user fills them in
                const isVoicePhoneFromDw = this.hasDwProvidedValue(
                    location,
                    'dwVoicePhone',
                    ['locationVoicePhone', 'voicePhone', 'phone']
                );
                const shouldFallbackLockVoicePhone = this.shouldFallbackLockLegacySearchField(location, 'voicePhone');
                if (!isVoicePhoneFromDw && !shouldFallbackLockVoicePhone) {
                    this.locationFormGroup.get('voicePhone')?.enable();
                }
                const isEmailFromDw = this.hasDwProvidedValue(
                    location,
                    'dwEmail',
                    ['email', 'locationEmail']
                );
                if (!isEmailFromDw) {
                    this.locationFormGroup.get('email')?.enable();
                }
                const isOfficeTypeFromDw = this.hasDwProvidedValue(
                    location,
                    'dwOfficeTypeID',
                    ['officeTypeID', 'officeTypeId']
                );
                if (!isOfficeTypeFromDw) {
                    this.locationFormGroup.get('officeTypeID')?.enable();
                }
                this.locationFormGroup.get('startDate')?.enable();
                this.locationFormGroup.get('endDate')?.enable();
            }
        }
        this.applyStoredLocationFieldState(location);
        this.markInvalidLocationFieldsAsTouched();
        if (this.directoryArray.length > 0) {
            const matchedObj = this.directoryArray.find((item: any) => item?.locationId == this.editLocationId);
            this.directoryData = matchedObj ? matchedObj : this.directoryData;
        }
    }

    private isMergedDwLocationEdit(location: any): boolean {
        return !!this.editLocationId &&
            !!location?.esLocationId &&
            !location?.isLocationFromTINSearch &&
            !!this.showTinAndPayeeSectionsForEdit;
    }

    private isEmptyLocationFieldValue(value: any): boolean {
        return value === null || value === undefined || (typeof value === 'string' && value.trim() === '');
    }

    private getFirstNonEmptyLocationValue(source: any, keys: string[]): any {
        if (!source) {
            return null;
        }
        for (const key of keys) {
            if (!this.isEmptyLocationFieldValue(source[key])) {
                return source[key];
            }
        }
        return null;
    }

    private isTrueLikeValue(value: any): boolean {
        return value === true || value === 'true' || value === 1 || value === '1' || value === 'Yes' || value === 'yes';
    }

    private getStoredLocationFieldLockState(location: any): Record<string, boolean> | null {
        if (!location || typeof location !== 'object' || !location.locationFieldLockState || typeof location.locationFieldLockState !== 'object') {
            return null;
        }

        const resolvedState: Record<string, boolean> = {};
        this.locationFieldLockControls.forEach((controlName: string) => {
            if (!Object.prototype.hasOwnProperty.call(location.locationFieldLockState, controlName)) {
                return;
            }
            resolvedState[controlName] = this.isTrueLikeValue(location.locationFieldLockState[controlName]);
        });

        return Object.keys(resolvedState).length ? resolvedState : null;
    }

    private captureLocationFieldLockState(): Record<string, boolean> {
        const lockState: Record<string, boolean> = {};
        this.locationFieldLockControls.forEach((controlName: string) => {
            lockState[controlName] = this.locationFormGroup.get(controlName)?.disabled === true;
        });
        return lockState;
    }

    private applyStoredLocationFieldState(location: any): void {
        const storedState = this.getStoredLocationFieldLockState(location);
        if (!storedState) {
            return;
        }
        this.locationFieldLockControls.forEach((controlName: string) => {
            if (controlName === 'tin') {
                return;
            }
            const control = this.locationFormGroup.get(controlName);
            if (!control) {
                return;
            }
            if (storedState[controlName]) {
                control.disable();
            } else {
                control.enable();
            }
        });
        this.locationFormGroup.get('tin')?.disable();
    }

    private shouldFallbackLockLegacySearchField(location: any, fieldControl: 'voicePhone' | 'email' | 'officeTypeID'): boolean {
        if (!location?.esLocationId || location?.isLocationFromTINSearch !== true) {
            return false;
        }
        if (this.getStoredLocationFieldLockState(location)) {
            return false;
        }
        const explicitDwFieldByControl: Record<string, string> = {
            voicePhone: 'dwVoicePhone',
            email: 'dwEmail',
            officeTypeID: 'dwOfficeTypeID'
        };
        const explicitDwField = explicitDwFieldByControl[fieldControl];
        if (Object.prototype.hasOwnProperty.call(location || {}, explicitDwField)) {
            return false;
        }
        const hasDwBaseline = !!this.getDwBaselineLocation(location);
        if (hasDwBaseline) {
            return false;
        }
        const fieldKeys = fieldControl === 'officeTypeID' ? ['officeTypeID', 'officeTypeId'] : [fieldControl];
        const fieldValue = this.getFirstNonEmptyLocationValue(location, fieldKeys);
        return !this.isEmptyLocationFieldValue(fieldValue);
    }

    private getDwBaselineLocation(location: any): any {
        const selectedEsLocationId = `${location?.esLocationId ?? this.selectedItem?.esLocationId ?? ''}`;
        if (!selectedEsLocationId) {
            return null;
        }
        const whLocations: any[] = JSON.parse((localStorage.getItem('whLocations') || '[]'));
        if (!Array.isArray(whLocations)) {
            return null;
        }
        const whMatch = whLocations.find((wh: any) => `${wh?.esLocationId ?? wh?.locationId ?? ''}` === selectedEsLocationId) ?? null;
        if (whMatch) {
            return whMatch;
        }
        const searchTinResponse: any[] = JSON.parse((localStorage.getItem('SearchTINResponse') || '[]'));
        if (!Array.isArray(searchTinResponse)) {
            return null;
        }
        return searchTinResponse.find((record: any) => {
            const recordEsLocationId = `${record?.esLocationId ?? ''}`;
            const recordLocationId = `${record?.locationId ?? ''}`;
            return recordEsLocationId === selectedEsLocationId || recordLocationId === selectedEsLocationId;
        }) ?? null;
    }

    private hasDwProvidedValue(location: any, explicitDwField: string | null, baselineFields: string[]): boolean {
        if (location && explicitDwField && Object.prototype.hasOwnProperty.call(location, explicitDwField)) {
            const explicitValue = location[explicitDwField];
            if (!this.isEmptyLocationFieldValue(explicitValue)) {
                return true;
            }
        }
        const baselineLocation = this.getDwBaselineLocation(location);
        const baselineValue = this.getFirstNonEmptyLocationValue(baselineLocation, baselineFields);
        return !this.isEmptyLocationFieldValue(baselineValue);
    }

    private resolveDwSourceValue(location: any, explicitDwField: string | null, baselineFields: string[]): any {
        if (location && explicitDwField && Object.prototype.hasOwnProperty.call(location, explicitDwField)) {
            const explicitValue = location[explicitDwField];
            if (!this.isEmptyLocationFieldValue(explicitValue)) {
                return explicitValue;
            }
        }
        const baselineLocation = this.getDwBaselineLocation(location);
        const baselineValue = this.getFirstNonEmptyLocationValue(baselineLocation, baselineFields);
        return this.isEmptyLocationFieldValue(baselineValue) ? null : baselineValue;
    }

    private applyMergedDwLocationFieldState(location: any): void {
        const mergedEditableFieldConfig: Record<string, { explicitDwField: string | null; baselineFields: string[] }> = {
            officeTypeID: { explicitDwField: 'dwOfficeTypeID', baselineFields: ['officeTypeID', 'officeTypeId'] },
            voicePhone: { explicitDwField: 'dwVoicePhone', baselineFields: ['locationVoicePhone', 'voicePhone', 'phone'] },
            email: { explicitDwField: 'dwEmail', baselineFields: ['email', 'locationEmail'] }
        };
        Object.keys(this.locationFormGroup.controls).forEach((key: string) => {
            const control = this.locationFormGroup.get(key);
            if (!control) {
                return;
            }
            if (key === 'startDate' || key === 'endDate') {
                if (this.impersonatedUser) {
                    control.disable();
                } else {
                    control.enable();
                }
                return;
            }

            const fieldConfig = mergedEditableFieldConfig[key];
            if (fieldConfig) {
                if (key === 'officeTypeID') {
                    const hasExplicitDwOfficeType =
                        Object.prototype.hasOwnProperty.call(location || {}, 'dwOfficeTypeID') &&
                        !this.isEmptyLocationFieldValue(location?.dwOfficeTypeID);
                    const currentOfficeType = this.getFirstNonEmptyLocationValue(location, ['officeTypeID', 'officeTypeId']);
                    const shouldLockOfficeType = hasExplicitDwOfficeType || !this.isEmptyLocationFieldValue(currentOfficeType);
                    if (this.impersonatedUser || shouldLockOfficeType) {
                        control.disable();
                    } else {
                        control.enable();
                    }
                    return;
                }

                const shouldLockField = this.hasDwProvidedValue(
                    location,
                    fieldConfig.explicitDwField,
                    fieldConfig.baselineFields
                );
                if (this.impersonatedUser || shouldLockField) {
                    control.disable();
                } else {
                    control.enable();
                }
                return;
            }

            control.disable();
        });
    }

    canDeactivate(): boolean | Observable<boolean> {
        if (this.isSubmitTriggered) {
            return true;
        }
        if (!this.hasUnsavedLocationPayeeTinChanges()) {
            return true;
        }
        return this.showUnsavedLocationPayeeAlert();
    }

    private hasUnsavedLocationPayeeTinChanges(): boolean {
        const hasParentFormChanges =
            this.locationFormGroup.dirty ||
            this.primaryLocationFormGroup.dirty ||
            this.practiceFormGroup.dirty ||
            this.participatingFormGroup.dirty ||
            this.ServiceCheckForm.dirty ||
            this.isDocChanges;

        if (hasParentFormChanges) {
            return true;
        }

        if (!this.createTinComponent) {
            return false;
        }

        return (
            this.createTinComponent.tinFormGroup.dirty ||
            this.createTinComponent.payeeFormGroup.dirty ||
            this.createTinComponent.serviceCheckForm.dirty ||
            this.createTinComponent.selectedExistingPayeeControl.dirty
        );
    }

    private showUnsavedLocationPayeeAlert(): Observable<boolean> {
        this.loader.hide();
        const alertMessage = 'Unsaved location and payee details will be lost. Are you sure you want to leave this page?';
        const dialogRef = this.dialog.open(W9AlertComponent, {
            disableClose: true,
            data: { message: alertMessage },
            width: '550px',
            backdropClass: '',
            hasBackdrop: true,
        });
        return dialogRef.afterClosed().pipe(
            map((result: any) => result === true)
        );
    }

    setParticipating(selectedLoc: any) {
        let network = selectedLoc.providerNetwork;
        const whLocations: any[] = JSON.parse((localStorage.getItem('whLocations') || '[]'))
        if (!network && selectedLoc.esLocationId) {
            const match = whLocations?.find(
                (wh: any) => wh.esLocationId === selectedLoc.esLocationId
            );
            network = match?.providerNetwork;
        }
        if (this.isLocationFromTinSearch) {
            this.isPar = selectedLoc?.isParticipating === false ? false : true;
        } else {
            this.isPar = network == 'Participating' ? true : network == 'Not participating' ? false : null;
        }

    }

    getDocuments() {
        let docs = localStorage.getItem('documents')
        this.documents = docs ? JSON.parse(docs) : []
        this.documentsMap = null
        this.corporateAuthSigned = false
        let hasMatchingCorpAuthDoc = false

        for (const doc of this.documents) {
            if (doc.categoryId == DocumentCategory.Location) {
                if (doc.subCategoryId == DocumentSubCategory.CorporateAuthorityForm && this.documentId == doc.documentId) {
                    hasMatchingCorpAuthDoc = true
                    this.corporateAuthSigned = doc.isSigned
                    this.documentsMap = {
                        originalFileName: `${doc.fileName}.pdf`,
                        name: `corpoate_authority_form.pdf`,
                        isSigned: doc.isSigned,
                        documentId: doc.documentId
                    }

                }

            }
        }
        if (!hasMatchingCorpAuthDoc) {
            this.documentId = null;
        }
    }

    onFormReadAndSign() {
        this.getDocuments();
        const credentials = JSON.parse(localStorage.getItem('credential')!);
        if (!credentials?.length || !credentials[0]?.stateLicenseNumber || !credentials[0]?.stateLicenseEffectiveDate) {
            const alertMessage = `To continue, select Save Location to save your work and retain your data while moving between screens.
                            Then navigate to the Dental Credentials tab, enter the State License and Effective Date, and return to this form to complete the signature.`;
            this.dialog.open(PopupComponent, {
                disableClose: true,
                data: { headerMessage: 'Alert', message: alertMessage, isPTESaved: true },
                width: '550px',
                backdropClass: '',
                hasBackdrop: true,
            });
            return;
        }
        this.showCorpAuthPopup = true;
        this.dataToCorpForm = this.locationFormGroup.getRawValue();
        const serviceLocationCheckedFromCreateTin = this.createTinComponent?.serviceCheckForm?.get('serviceLocationChecked')?.value;
        this.dataToCorpForm['serviceLocationChecked'] =
            serviceLocationCheckedFromCreateTin !== undefined
                ? serviceLocationCheckedFromCreateTin
                : this.ServiceCheckForm.get('serviceLocationChecked')?.value;
        if (this.showTinAndPayeeSections && this.createTinComponent?.payeeFormGroup) {
            const payeeData = this.createTinComponent.payeeFormGroup.getRawValue();
            this.dataToCorpForm = {
                ...this.dataToCorpForm,
                payeeName: payeeData?.payeeName || '',
                payeeAddressLine1: payeeData?.payeeLocation || '',
                payeeAddressLine2: payeeData?.payeeAddress2 || '',
                payeeCity: payeeData?.payeeCity || '',
                payeeState: payeeData?.payeeState || '',
                payeeZip: payeeData?.payeeZip || '',
                payeePhone: payeeData?.payeePhone || '',
                payeeEmail: payeeData?.payeeEmail || '',
                payeeNPI: payeeData?.npi2 || ''
            };
        }
        let demographicObj = localStorage.getItem('demographics')
        let demographicData = demographicObj ? JSON.parse(demographicObj) : null;
        let dentistData = localStorage.getItem('dentistInfo')
        let dentistInfo = dentistData ? JSON.parse(dentistData) : null;
        const loggedUserDetails = JSON.parse(localStorage.getItem("loggedUserDetails") || '{}')
        if (demographicData && (demographicData.firstName && (demographicData.lastName))) {
            let lastName = demographicData.lastName ? demographicData.lastName : '';
            this.dataToCorpForm.dentistName = `${demographicData.firstName} ${lastName}`
        } else {
            this.dataToCorpForm.dentistName = (loggedUserDetails['firstName'] && loggedUserDetails['lastName']) ? `${loggedUserDetails['firstName']} ${loggedUserDetails['lastName']}` : ""
        }
        if (dentistInfo) {
            this.dataToCorpForm.stateLicense = dentistInfo.licenseState ? dentistInfo.licenseState : null;
            this.dataToCorpForm.npi = dentistInfo.npi ? dentistInfo.npi : null;
        }

    }

    onReadAndSign() {
        this.showDirectoryInfoPopup = true;

    }

    onCorpAuthDone(event: any) {
        this.corporateAuthSigned = true;
        this.beforeCorpAuthSignedData = this.locationFormGroup.getRawValue();
        const serviceLocationChecked = this.createTinComponent?.serviceCheckForm?.get('serviceLocationChecked')?.value;
        this.beforeCorpAuthSignedData['serviceLocationChecked'] =
            serviceLocationChecked !== undefined
                ? serviceLocationChecked
                : this.ServiceCheckForm.get('serviceLocationChecked')?.value;
        this.beforeCorpAuthSignedData['isPrimary'] = this.primaryLocationFormGroup.get('isPrimary')?.value;
        this.beforeCorpAuthSignedData['isParticipating'] = this.participatingFormGroup.get('isParticipating')?.value;
        this.beforeCorpAuthSignedData['isPracticing'] = this.practiceFormGroup.get('isPracticing')?.value;
        if (this.createTinComponent?.payeeFormGroup) {
            const payeeData = this.createTinComponent.payeeFormGroup.getRawValue();
            this.beforeCorpAuthSignedData['payeeName'] = payeeData?.payeeName || null;
            this.beforeCorpAuthSignedData['payeeAddressLine1'] = payeeData?.payeeLocation || null;
            this.beforeCorpAuthSignedData['payeeAddressLine2'] = payeeData?.payeeAddress2 || null;
            this.beforeCorpAuthSignedData['payeeCity'] = payeeData?.payeeCity || null;
            this.beforeCorpAuthSignedData['payeeState'] = payeeData?.payeeState || null;
            this.beforeCorpAuthSignedData['payeeZip'] = payeeData?.payeeZip || null;
            this.beforeCorpAuthSignedData['payeePhone'] = payeeData?.payeePhone || null;
            this.beforeCorpAuthSignedData['payeeEmail'] = payeeData?.payeeEmail || null;
            this.beforeCorpAuthSignedData['payeeNPI'] = payeeData?.npi2 || null;
            this.beforeCorpAuthSignedData['hasPayeeSnapshot'] = true;
        } else {
            this.beforeCorpAuthSignedData['hasPayeeSnapshot'] = false;
            this.beforeCorpAuthSignedData['payeePhone'] = null;
            this.beforeCorpAuthSignedData['payeeEmail'] = null;
            this.beforeCorpAuthSignedData['payeeNPI'] = null;
        }
        this.showCorpAuthPopup = false;
        this.isDocChanges = true;
        this.documentId = event.documentId;
        if (this.documentId) {
            this.getDocuments();
        }

        if (this.isWhLocation) {
            this.disableForm();
        }

    }

    onDeleteDocument(event: any) {
        this.corporateAuthSigned = false;
        this.isDocChanges = true;
        if (!this.isWhLocation) {
            this.enableForm();
        }
    }

    onCorpAuthClose() {
        this.showCorpAuthPopup = false;
    }

    onDirectoryInfoSubmit(event: any) {
        this.directoryInfoSigned = true;
        this.showDirectoryInfoPopup = false;
        this.directoryData = event;
        localStorage.setItem(this.DIRECTORY_INFO_SIGNED_KEY, 'true');
        localStorage.setItem(this.PENDING_LOCATION_DIRECTORY_DATA_KEY, JSON.stringify(event));
    }

    onDirectoryInfoClose() {
        this.showDirectoryInfoPopup = false;
    }

    onCreateTinSaveCompleted() {
        this.isSubmitTriggered = true;
    }

    onCreateTinCorpAuthCleared() {
        this.corporateAuthSigned = false;
        this.documentId = null;
        this.documentsMap = null;
    }

    private navigateToLocationsLanding() {
        this.router.navigateByUrl('/credentialing/locations', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/credentialing/locations']);
        });
    }

    onSaveClick() {
        if (!this.sharedService.validateFormLimits(this.locationFormGroup, this.FIELD_LIMITS)) return;
        if (this.hasInvalidLocationSaveState(true)) return;
        if (this.showTinAndPayeeSections && this.createTinComponent?.createNeedtoDisable()) return;
        const isRecred = this.getAction();
        const existingLocations = JSON.parse(localStorage.getItem('locations') || '[]');
        const hasEditLocationId = this.editLocationId !== null && this.editLocationId !== undefined && `${this.editLocationId}` !== '';
        const existingLocation = hasEditLocationId
            ? (
                existingLocations.find(
                    (loc: any) => loc.locationId == this.editLocationId || loc.esLocationId == this.editLocationId
                ) || []
            )
            : [];
        const isLocationUpdated = this.isLocationChanged(existingLocation, this.locationFormGroup.getRawValue());
        const isCorpAuthSensitiveLocationChange = this.isCorpAuthSensitiveLocationChange();
        const isApiComparableLocationChange = this.isApiComparableLocationChanged(existingLocation);
        const isCorpAuthSensitivePayeeChange = this.isCorpAuthSensitivePayeeChange();
        const isCorpAuthCurrentlyRequired = this.isCorpAuthRequierd();
        const existingMappedCorpAuthDocumentId = existingLocation?.dcaDocumentId ?? existingLocation?.dcaDocumentID ?? null;
        const hasMappedCorpAuthDocument = existingMappedCorpAuthDocumentId != null;
        const wasParticipatingWhenSigned = this.getBooleanValue(
            this.beforeCorpAuthSignedData?.['isParticipating'] ?? existingLocation?.isParticipating
        );
        const isCorpAuthRemovalRequired = hasMappedCorpAuthDocument && wasParticipatingWhenSigned === true && !isCorpAuthCurrentlyRequired;
        const isCorpAuthResignRequired =
            hasEditLocationId &&
            hasMappedCorpAuthDocument &&
            isRecred &&
            isCorpAuthCurrentlyRequired &&
            (isApiComparableLocationChange || isCorpAuthSensitiveLocationChange || isCorpAuthSensitivePayeeChange);
        const isCorpAuthDeleteRequired = isCorpAuthRemovalRequired || isCorpAuthResignRequired;
        const isPrimary = this.primaryLocationFormGroup.get('isPrimary')?.value === 'yes' ? true : this.primaryLocationFormGroup.get('isPrimary')?.value === 'no' ? false : null;
        const isPADocDeleteRequired = ((isPrimary || existingLocation?.isPrimary) && (isLocationUpdated || this.isPayeeUpdated() )) ? true : false;
        const isw9DeleteRequired = !this.isW9Required;
        if(isw9DeleteRequired){
            this.createTinComponent?.deleteW9Document(true);
            this.loader.show()
        }
        if (isCorpAuthDeleteRequired) {
            const currentDocumentId = existingMappedCorpAuthDocumentId;
            this.corporateAuthSigned = false;
            this.documentId = null;
            this.documentsMap = null;
            const locations = JSON.parse(localStorage.getItem('locations') || '[]');
            if (Array.isArray(locations)) {
                const updatedLocations = locations.map((location: any) => {
                    const isSameLocation =
                        `${location?.locationId ?? ''}` === `${this.editLocationId ?? ''}` ||
                        `${location?.esLocationId ?? ''}` === `${this.editLocationId ?? ''}`;
                    return isSameLocation
                        ? { ...location, isCorpAuthResignRequired: true }
                        : location;
                });
                localStorage.setItem('locations', JSON.stringify(updatedLocations));
            }
            const documents = JSON.parse(localStorage.getItem('documents') || '[]');
            const doc = currentDocumentId == null
                ? null
                : documents.find((d: any) =>
                    d.categoryId == DocumentCategory.Location &&
                    d.subCategoryId == DocumentSubCategory.CorporateAuthorityForm &&
                    d.documentId == currentDocumentId
                );
            const filename = doc ? doc.fileName : '';
            if (filename) {
                this.deleteDocument(filename, DocumentSubCategory.CorporateAuthorityForm, doc?.documentId);
            }
        }
        if (isPADocDeleteRequired) {
            const documents = JSON.parse(localStorage.getItem('documents') || '[]');
            const doc = documents?.find((d: any) => d.categoryId == DocumentCategory.SignedDocument && d.subCategoryId == DocumentSubCategory.ParticipatingAgreement);
            const filename = doc ? doc.fileName : '';
            if (filename) {
                this.deleteDocument(filename, DocumentSubCategory.ParticipatingAgreement);
            }
        }
        this.onAddLocation(false).subscribe({
            next: () => {
                if (this.showTinAndPayeeSections && this.createTinComponent) {
                    if (isCorpAuthResignRequired) localStorage.setItem('isCorpAuthDeleteRequired', 'true');
                    this.createTinComponent.onSave();
                } else {
                    if (isCorpAuthResignRequired) {
                        const alertMessage = `Please read and sign the corporate authority.`;
                        this.dialog.open(PopupComponent, {
                            disableClose: true,
                            data: { headerMessage: 'Alert', message: alertMessage, isPTESaved: true },
                            width: '550px',
                            backdropClass: '',
                            hasBackdrop: true,
                        });
                    }
                    localStorage.removeItem('editLocationId');
                    this.navigateToLocationsLanding();
                }
            },
            error: (err) => {
            }
        });
    }
    isPayeeUpdated(): boolean {
        const taxEntities = JSON.parse(localStorage.getItem('taxEntities') || '[]');
        const taxEntity = taxEntities.find((entity: any) =>
            entity.locations?.some(
                (location: any) => location.locationId == this.editLocationId
            )
        );
        const payee = taxEntity?.payees?.find(
            (payee: any) => payee.locationId == this.editLocationId
        );
        if (!payee) return false;
        const form: any = this.createTinComponent?.payeeFormGroup.getRawValue();
        return (
            form.payeeName !== payee.payeeName ||
            form.payeeAddress2 !== payee.payeeAddress2 ||
            form.payeeCity !== payee.payeeCity ||
            form.payeeState !== payee.payeeState ||
            form.payeeZip !== payee.payeeZip ||
            form.payeePhone !== payee.payeeVoicePhone ||
            form.payeeEmail !== payee.payeeEmail ||
            form.npi2?.trim() !== payee.payeeNPI?.trim()
        );
    } 
    onAddLocation(isAutoSave: any): Observable<any> {
        this.isSubmitTriggered = true;
        this.loader.show();
        const formData = this.locationFormGroup.getRawValue();
        const isNewTinFlow = localStorage.getItem('isnewTIN') === 'true';
        if (isNewTinFlow && !formData.tin) {
            this.loader.hide();
            return EMPTY; // stops execution cleanly
        }
        if (isNewTinFlow && this.ServiceCheckForm.get('serviceLocationChecked')?.value) {
            if (!formData.location || !formData.city || !formData.state || !formData.zip) {
                this.showError = true;
                this.loader.hide();
                return EMPTY; // stops execution cleanly
            }
        }
        // WAIT for W9 API response    
        if (isNewTinFlow && formData.tin) {

            return this.isW9needed(formData.tin).pipe(
                switchMap(() => this.processLocationSave(formData))
            );
        }
        return this.processLocationSave(formData);
    }

    onBack() {
        if ((!this.isLocationFromTinSearch && sessionStorage.getItem("selectedLocationRecord") && !this.editLocationId) || (!this.editLocationId && localStorage.getItem("SearchedTin"))) {
            this.router.navigate(['credentialing/search-tin'])
        } else {
            this.router.navigate(['/credentialing/locations']);
        }
    }

    onCancel() {
        this.navigateToLocationsLanding();
    }

    ngOnDestroy() {
        localStorage.removeItem('SearchedTin');
        localStorage.removeItem('editLocationId');
        localStorage.removeItem("locationValueFromTINSave")
        localStorage.removeItem("TINValueFromTINSave")
        window.removeEventListener('scroll', this.scrollHandler, true);
        window.removeEventListener('touchmove', this.scrollHandler, true);
        this.tinEffectiveDateValidationSubscription?.unsubscribe();
    }

    private startDateAfterOrOnTinEffectiveDateValidator(control: AbstractControl): ValidationErrors | null {
        if (localStorage.getItem('isnewTIN') !== 'true') {
            return null;
        }

        if (!control.value) {
            return null;
        }

        const tinEffectiveDateValue = this.createTinComponent?.tinFormGroup.get('effectiveDate')?.value;
        if (!tinEffectiveDateValue) {
            return null;
        }

        const startDate = this.toComparableDate(control.value);
        const tinEffectiveDate = this.toComparableDate(tinEffectiveDateValue);

        if (!startDate || !tinEffectiveDate) {
            return null;
        }

        return startDate >= tinEffectiveDate
            ? null
            : { startDateAfterOrOnTinEffectiveDate: true };
    }

    private subscribeTinEffectiveDateValidation() {
        this.tinEffectiveDateValidationSubscription?.unsubscribe();
        const effectiveDateControl = this.createTinComponent?.tinFormGroup.get('effectiveDate');
        if (!effectiveDateControl) {
            return;
        }

        this.tinEffectiveDateValidationSubscription = effectiveDateControl.valueChanges.subscribe(() => {
            this.locationFormGroup.get('startDate')?.updateValueAndValidity({ emitEvent: false });
        });
        this.locationFormGroup.get('startDate')?.updateValueAndValidity({ emitEvent: false });
    }

    private toComparableDate(value: any): Date | null {
        if (!value) {
            return null;
        }

        const rawValue = `${value}`.trim();
        const normalizedValue = /^\d{8}$/.test(rawValue)
            ? `${rawValue.slice(0, 4)}-${rawValue.slice(4, 6)}-${rawValue.slice(6, 8)}`
            : value;

        const date = new Date(normalizedValue);
        if (isNaN(date.getTime())) {
            return null;
        }

        date.setHours(0, 0, 0, 0);
        return date;
    }

    private callDocAndDirectoryqns(id: any, eventId: any): Observable<any> {
        const loginUserId = localStorage.getItem("loggedUserId");
        let payload = {
            ...this.directoryData,
            locationId: id,
            credentialingEventId: eventId,
            userId: loginUserId ? Number(loginUserId) : 0
        }
        return this.service.saveDirectory(payload).pipe(
            map((response: any) => {
                if (payload.locationDirectoryId == null) {
                    payload.locationDirectoryId = response.locationDirectoryId
                    this.directoryArray = [...this.directoryArray, payload]
                } else {
                    const index = this.directoryArray.findIndex((item: any) => item.locationDirectoryId == payload.locationDirectoryId);
                    if (index != -1) {
                        this.directoryArray = this.directoryArray.map((l: any, i: any) => i === index ? { ...l, ...payload } : l);
                    }
                }
                localStorage.setItem('locationDirectories', JSON.stringify(this.directoryArray))
                localStorage.removeItem(this.DIRECTORY_INFO_SIGNED_KEY);
                localStorage.removeItem(this.PENDING_LOCATION_DIRECTORY_DATA_KEY);
                return response;
            }),
            catchError((err: any) => {
                this.sharedService.logError("APIFailed", "FileAddLocationComponent - saveDirectory, Method:callDocAndDirectoryqns", this.router.url.split('?')[0], err).subscribe();
                return throwError(() => err);
            })
        );
    }

    formatData(location: any, eventId: any) {
        const loginUserId = localStorage.getItem("loggedUserId");
        return location.map((item: any) => ({
            locationId: item.locationId,
            name: item.name,
            address: item.address1,
            city: item.city,
            state: item.state,
            zip: item.zip,
            tin: item.tin,
            isPrimary: item.isPrimary,
            ...(item.hasOwnProperty('isLocationFromTINSearch') && {
                isLocationFromTINSearch: item.isLocationFromTINSearch
            }),
            userId: loginUserId ? Number(loginUserId) : 0,
            credentialingEventId: eventId,
            stillPracticing: item.stillPracticing,
            startPracticingAt: item.startPracticingAt ? item.startPracticingAt : null,
            endedPracticingAt: item.endedPracticingAt ? item.endedPracticingAt : null,
            isParticipating: item.isParticipating,
            esLocationId: item.esLocationId,
            dcaDocumentId: item.dcaDocumentId,
            officeTypeID: item.officeTypeID,
            voicePhone: item.voicePhone,
            email: item.email
        }));
    }

    disableForm() {
        Object.keys(this.locationFormGroup.controls).forEach(key => {
            if (key !== 'startDate' && key !== 'endDate' && key !== 'officeTypeID' && key !== 'voicePhone' && key !== 'email') {
                this.locationFormGroup.get(key)?.disable();
            }
        });
    }
    enableForm() {
        this.locationFormGroup.enable();
    }

    private getStorageArray(key: string): any[] {
        const parsed = JSON.parse(localStorage.getItem(key) || '[]');
        if (Array.isArray(parsed)) {
            return parsed;
        }
        return parsed ? [parsed] : [];
    }

    private syncExistingPrimaryLocationState(): void {
        const sessionLocations = Array.isArray(this.locations) ? this.locations : [];
        const whLocations = this.getStorageArray('whLocations');
        const allLocations = [...sessionLocations, ...whLocations];
        this.existingPrimaryLocationRef = allLocations.find((loc: any) => loc?.isPrimary === true) || null;
        this.hasPrimaryLocation = !!this.existingPrimaryLocationRef;
        this.primaryLocationId = this.existingPrimaryLocationRef
            ? (this.existingPrimaryLocationRef.locationId ?? this.existingPrimaryLocationRef.esLocationId ?? null)
            : null;
    }

    private isEditingExistingPrimaryLocation(): boolean {
        if (!this.editLocationId || !this.existingPrimaryLocationRef) {
            return false;
        }

        const currentEditId = `${this.editLocationId}`;
        const existingPrimaryIds = [this.existingPrimaryLocationRef.locationId, this.existingPrimaryLocationRef.esLocationId]
            .filter((id: any) => id !== null && id !== undefined && `${id}` !== '')
            .map((id: any) => `${id}`);
        return existingPrimaryIds.includes(currentEditId);
    }

    checkPrimaryExist(value: any) {
        if (value !== 'yes') {
            return;
        }

        this.syncExistingPrimaryLocationState();
        if (!this.hasPrimaryLocation || this.isEditingExistingPrimaryLocation()) {
            return;
        }

        const control = this.primaryLocationFormGroup.get('isPrimary');
        this.W9AlertPopupCall(false, true)
        setTimeout(() => {
            control?.setValue('no');
        });
    }
    formatDate(date: any) {
        return this.datePipe.transform(date, 'yyyy-MM-dd');
    }
    getTinHasParticipatingLocation(): boolean {
        const tin = this.selectedItem && this.selectedItem.taxId ? this.selectedItem.taxId : this.locationFormGroup.get('tin')?.value ? this.locationFormGroup.get('tin')?.value : '';
        if (!tin) {
            return false;
        }
        const locations = JSON.parse(localStorage.getItem('locations') || '[]');
        const tinHasparticipatingLoc = locations.some((loc: any) => {
            const locationTin = loc.taxId ? loc.taxId : loc.tin;
            if (!this.isSameTinIdentifier(locationTin, tin)) {
                return false;
            }
            if (this.isCurrentEditLocation(loc)) {
                return false;
            }
            return this.getBooleanValue(loc.isParticipating) === true;
        });
        return tinHasparticipatingLoc;
    }

    shouldDeleteW9OnLocationSave(): boolean {
        const hasEditLocationId = this.editLocationId !== null && this.editLocationId !== undefined && `${this.editLocationId}` !== '';
        if (!hasEditLocationId) {
            return false;
        }
        const existingLocations = JSON.parse(localStorage.getItem('locations') || '[]');
        const existingLocation = existingLocations.find(
            (loc: any) => loc.locationId == this.editLocationId || loc.esLocationId == this.editLocationId
        );
        const wasParticipating = this.getBooleanValue(
            this.beforeCorpAuthSignedData?.['isParticipating'] ?? existingLocation?.isParticipating
        );
        const isParticipatingNow = this.getBooleanValue(this.participatingFormGroup.get('isParticipating')?.value);
        if (wasParticipating !== true || isParticipatingNow !== false) {
            return false;
        }

        const tin =
            this.locationFormGroup.get('tin')?.value ??
            existingLocation?.taxId ??
            existingLocation?.tin ??
            '';
        if (!tin) {
            return false;
        }

        return !this.getTinHasParticipatingLocation();
    }

    private isCurrentEditLocation(location: any): boolean {
        if (!this.editLocationId) {
            return false;
        }
        const editId = `${this.editLocationId}`;
        const locationIds = [location?.locationId, location?.esLocationId]
            .filter((id: any) => id !== undefined && id !== null && `${id}` !== '')
            .map((id: any) => `${id}`);
        return locationIds.includes(editId);
    }

    onPracticeChange() {
        if (this.isWhLocation && this.isPar && this.practiceFormGroup.get('isPracticing')?.value === 'no') {            
            this.isW9Required = !this.getTinHasParticipatingLocation() ? false : true;
            this.locationFormGroup.get('startDate')?.enable();
            this.locationFormGroup.get('endDate')?.setValidators([Validators.required]);
            this.primaryLocationFormGroup.get('isPrimary')?.setValue('no');
            this.primaryLocationFormGroup.get('isPrimary')?.disable();
            this.locationFormGroup.get('endDate')?.enable();
            this.locationFormGroup.get('startDate')?.updateValueAndValidity();
            this.locationFormGroup.get('endDate')?.updateValueAndValidity();
        } else {
            this.isW9Required = true;
            this.locationFormGroup.get('endDate')?.clearValidators();
            this.locationFormGroup.get('endDate')?.reset();
            this.primaryLocationFormGroup.get('isPrimary')?.enable();
        }

    }
    onBlur(event: any) {
        if (event?.target.value.length == 0) { this.showError = true }
    }
    onLocationChange(val: any) {
        $('.pac-container').addClass('hide');
        if (val.length > 0) { this.showError = false
            this.showStateError = false;
            this.showFulladdressError = false;
         }
    }
    async onFocus() {
        $('.pac-container').addClass('hide');
        await this.repositionDropdown();
    }
    async repositionDropdown() {

        const input = this.locationInputs.get(0)?.nativeElement;
        const pacContainer = document.querySelector('.pac-container') as HTMLElement;

        if (pacContainer && input) {
            // Style positioning

            pacContainer.style.position = 'absolute';
            const rect = this.locationInputs.get(0)?.nativeElement.getBoundingClientRect();
            pacContainer.style.top = `${rect.bottom + window.scrollY}px`;
            pacContainer.style.left = `${rect.left}px`;
            pacContainer.style.width = `${rect.width}px`;
        }

    }

    async onScroll() {
        $('.pac-container').addClass('hide');
    }
    async ngAfterViewInit() {
        if ((window as any).google) {
            await this.initializeAutoComplete();
        }
        else {
            const interval = setInterval(async () => {
                if ((window as any).google) {
                    clearInterval(interval);
                    await this.initializeAutoComplete();
                }
            }, 300)
        }
        //
        this.locationInputs.changes.subscribe(async () => {
            $('.pac-container').addClass('hide');
            await this.initializeAutoComplete();
        })
        this.subscribeTinEffectiveDateValidation();
    }
    async initializeAutoComplete() {
        const visibleInputs = this.locationInputs.filter(
            (inputRef: ElementRef) =>
                !!inputRef.nativeElement.offsetParent
        )
        visibleInputs.forEach((inputRef) => {
            const autoComplete = new (window as any).google.maps.places.Autocomplete(
                inputRef.nativeElement, {
                types: ['address'],
                componentRestrictions: { country: 'us' }
            }
            );

            const autoCompleteService = new google.maps.places.AutocompleteService()

            autoComplete.addListener('place_changed', () => {
                this.ngZone.run(() => {
                    const place = autoComplete.getPlace();
                    if (place && place.formatted_address) {
                        this.showError = false;
                        this.showStateError = false;
                        this.selectedAddress = place.formatted_address || '';
                        this.isPlaceSelected = true;
                        let homeAddress = '';
                        let city = '';
                        let state = '';
                        let zip = '';
                        let streetNumber = '';
                        let route = '';
                        place.address_components?.forEach((component: any) => {

                            // Street Number
                            if (component.types.includes('street_number')) {
                                streetNumber = component.long_name;
                            }

                            // Street Name
                            if (component.types.includes('route')) {
                                route = component.long_name;
                            }
                            // City
                            if (!city && component.types.includes('locality')) {
                                city = component.long_name;
                            }
                            else if (!city && component.types.includes('postal_town')) {
                                city = component.long_name;
                            }
                            else if (!city && component.types.includes('sublocality')) {
                                city = component.long_name;
                            }
                            else if (!city && component.types.includes('administrative_area_level_2')) {
                                city = component.long_name;
                            }

                            // State
                            if (component.types.includes('administrative_area_level_1')) {
                                state = component.short_name;
                            }

                            // ZIP
                            if (component.types.includes('postal_code')) {
                                zip = component.long_name;
                            }
                        });
                        // Restrict states
                        if (!this.allowedStates.includes(state)) {
                            this.showStateError = true;
                            this.locationFormGroup.patchValue({
                                location: '',
                                city: '',
                                state: '',
                                zip: ''
                            });
                            inputRef.nativeElement.value = '';
                            return;
                        } else {
                            // Build address line
                            homeAddress = `${streetNumber} ${route}`.trim();
                            this.locationFormGroup.patchValue({
                                location: homeAddress,
                                city: city,
                                state: state,
                                zip: zip
                            });
                            if (!zip) {
                                this.showFulladdressError = true
                            } else {
                                this.showFulladdressError = false
                            }
                            this.validateLocation(this.selectedAddress);
                        }
                    }
                })
            })

            inputRef.nativeElement.addEventListener('input', (e: any) => {
                this.isPlaceSelected = false;
                const value = e.target.value;

                if (!value) {
                    this.suggestionCount = 0;
                    return;
                }
                autoCompleteService.getPlacePredictions(
                    {
                        input: value, types: ['address'],
                        componentRestrictions: { country: 'us' }
                    },
                    (predictions, status) => {
                        this.ngZone.run(async () => {
                            if (status === google.maps.places.PlacesServiceStatus.OK && predictions) {
                                await this.repositionDropdown();
                                $('.pac-container').removeClass('hide');
                                this.suggestionCount = predictions.length;
                            }
                            else {
                                this.suggestionCount = 0;
                            }
                        })
                    }
                )
            })
            const input = inputRef.nativeElement;
            input.setAttribute('placeholder', 'Type service address')
        })
        // Listen to scroll events (both page & nested containers)

        window.addEventListener('scroll', this.scrollHandler, true);
        window.addEventListener('touchmove', this.scrollHandler, true);

    }
    validateLocation(inputText: string): Promise<boolean> {
        return new Promise((resolve) => {
            if (!this.isPlaceSelected && (!inputText || inputText.trim().length < 3)) {
                resolve(false);
                return;
            }
            if (!this.isPlaceSelected && (!inputText || inputText.trim().length == 3)) {
                const geocoder = new google.maps.Geocoder();
                geocoder.geocode({ address: inputText }, (results: any, status: any) => {
                    if (status === google.maps.GeocoderStatus.OK) {
                        const valid = results.some((r: any) =>
                            r.types.includes('locality') || r.types.includes('administrative_area_level_1') || r.types.includes('country')
                        )
                        resolve(valid);
                    }
                    else {
                        resolve(false);
                    }
                })
                return;
            }
            const service = new google.maps.places.AutocompleteService();
            service.getPlacePredictions({ input: inputText }, (predictions: any, status) => {
                if (status === google.maps.places.PlacesServiceStatus.OK && predictions && predictions.length > 0) {
                    resolve(true);
                    return;
                }
                else {
                    const geocoder = new google.maps.Geocoder();
                    geocoder.geocode({ address: inputText }, (results: any, status: any) => {
                        if (status === google.maps.GeocoderStatus.OK && results && results.length > 0) {
                            resolve(true);
                        }
                        else {
                            resolve(false);
                        }
                    })
                }
            })

        })
    }
    isW9needed(tin: any): Observable<any> {
        this.loader.show();
        const payload = {
            taxId: tin,
            userId: localStorage.getItem('user_id'),
            credentialingEventId: localStorage.getItem('credentialingEventId')
        };

        return this.sharedService.getW9UploadStatus(payload).pipe(
            tap((res: any) => {
                if (res && !res.hasW9Uploaded) {
                    this.isExistingTIN = false;
                } else {
                    this.isExistingTIN = true;
                }
                this.loader.hide();
                return this.isExistingTIN;
            }),
            catchError((err: any) => {
                this.loader.hide();
                return of(null);
            })
        );
    }
    private processLocationSave(formData: any): Observable<any> {
        const eventId = localStorage.getItem('credentialingEventId');
        if (this.documentId) {
            const docs = localStorage.getItem('documents');
            this.documents = docs ? JSON.parse(docs) : [];
            const exists = this.documents.some(
                (doc: any) => doc.documentId == this.documentId
            );
            if (!exists) {
                this.documentId = null;
            }
        }
        let existingIds = new Set<number>();
        if (!this.editLocationId) {
            existingIds = new Set(
                this.locations
                    .map((l: any) => l.locationId)
                    .filter((id: any) => id != null)
                    .map((id: any) => Number(id))
            );
        }
        const payload = this.preparePayload(formData, eventId);
        const requestPayload = this.getLocationRequestPayload(payload, existingIds);
        if (localStorage.getItem('isnewTIN') === 'true' && !this.isExistingTIN) {
            if (this.directoryInfoSigned && this.primaryLocationFormGroup.get('isPrimary')?.value === 'yes') {
                localStorage.setItem(this.DIRECTORY_INFO_SIGNED_KEY, this.directoryInfoSigned.toString())
                if (this.directoryData) {
                    localStorage.setItem(this.PENDING_LOCATION_DIRECTORY_DATA_KEY, JSON.stringify(this.directoryData));
                }
            }
            requestPayload.forEach((location: any) => {
                if (location.locationId == null) {
                    location.serviceLocationChecked =
                        this.ServiceCheckForm.get('serviceLocationChecked')?.value;
                }
            });
            localStorage.setItem(
                'LocationSavePayload',
                JSON.stringify(requestPayload)
            );
            this.loader.hide();
            this.router.navigate([
                '/credentialing/locations/add-tin'
            ]);
            return EMPTY; // stops execution cleanly
        }
        return this.service.saveLocationPayeeTax({ locations: requestPayload }).pipe(
            catchError((err: any) => {
                this.service.deleteLocationFailedPopupCall(false, 'saveLocation');
                this.sharedService
                    .logError(
                        'APIFailed',
                        'FileAddLocationComponent - saveLocationPayeeTax, Method:onAddLocation',
                        this.router.url.split('?')[0],
                        err
                    )
                    .subscribe();
                return throwError(() => err);
            }),
            switchMap((response: any) => {
                const savedLocations = this.getSavedLocationRecords(response);
                let locationId;
                if (!this.editLocationId) {
                    const newLocFromApi = savedLocations.find(
                        (loc: any) =>
                            !existingIds.has(Number(loc.locationId))
                    );
                    locationId = newLocFromApi?.locationId ?? null;
                    if (newLocFromApi) {
                        localStorage.setItem('latestCreatedLocationId', String(newLocFromApi.locationId));
                        this.locations = this.locations.map((l: any) =>
                            l.locationId == null
                                ? {
                                    ...l,
                                    locationId: newLocFromApi.locationId,
                                    modifiedDate: newLocFromApi.modifiedDate,
                                    createdDate: newLocFromApi.createdDate
                                }
                                : l
                        );
                    }
                } else {
                    locationId = this.editLocationId;
                    const updatedLocFromApi = savedLocations.find(
                        (loc: any) =>
                            loc.locationId == this.editLocationId
                    );
                    if (updatedLocFromApi) {
                        this.locations = this.locations.map((l: any) =>
                            l.locationId == this.editLocationId
                                ? {
                                    ...l,
                                    ...updatedLocFromApi,
                                    email: !this.isEmptyLocationFieldValue(updatedLocFromApi?.locationEmail)
                                        ? updatedLocFromApi.locationEmail
                                        : (!this.isEmptyLocationFieldValue(updatedLocFromApi?.email)
                                            ? updatedLocFromApi.email
                                            : l?.email),
                                    modifiedDate: updatedLocFromApi.modifiedDate
                                }
                                : l
                        );
                    }
                }
                localStorage.setItem(
                    'locations',
                    JSON.stringify(this.locations)
                );
                if (this.directoryInfoSigned && this.primaryLocationFormGroup.get('isPrimary')?.value === 'yes') {
                    return this.callDocAndDirectoryqns(
                        locationId,
                        eventId
                    ).pipe(map(() => response));
                }
                return of(response);
            }),
            finalize(() => {
                this.loader.hide();
            })
        );
    }

    private getLocationRequestPayload(payload: any[], existingIds: Set<number>): any[] {
        if (!Array.isArray(payload) || payload.length === 0) {
            return [];
        }

        if (this.editLocationId) {
            const editedLocation = payload.find((item: any) =>
                `${item?.locationId ?? ''}` === `${this.editLocationId}` ||
                ((item?.locationId == null || item?.locationId === 0) && `${item?.esLocationId ?? ''}` === `${this.editLocationId}`)
            );
            return editedLocation ? [editedLocation] : payload;
        }

        const newlyAddedLocations = payload.filter((item: any) =>
            item?.locationId == null || !existingIds.has(Number(item.locationId))
        );

        if (newlyAddedLocations.length === 0) {
            return payload;
        }

        if (newlyAddedLocations.length === 1) {
            return newlyAddedLocations;
        }

        const selectedSearchLocationId = this.selectedLocationRecordFromTinSearch?.esLocationId;
        if (selectedSearchLocationId != null) {
            const matchedSearchLocation = newlyAddedLocations.find((item: any) =>
                item?.locationId == null && `${item?.esLocationId ?? ''}` === `${selectedSearchLocationId}`
            );
            if (matchedSearchLocation) {
                return [matchedSearchLocation];
            }
        }

        return [newlyAddedLocations[newlyAddedLocations.length - 1]];
    }

    private getSavedLocationRecords(response: any): any[] {
        if (Array.isArray(response)) {
            return response;
        }

        const collections = [
            response?.locations,
            response?.saveLocationResponse,
            response?.locationResponse,
            response?.data?.locations,
            response?.data?.saveLocationResponse,
            response?.data?.locationResponse
        ];

        for (const collection of collections) {
            if (Array.isArray(collection)) {
                return collection;
            }
        }

        if (response?.locationId != null) {
            return [response];
        }
        if (response?.data?.locationId != null) {
            return [response.data];
        }

        return [];
    }

    W9AlertPopupCall(isLocationExist?: any, isPrimaryLocationAlert?: any) {
        this.loader.hide();
        let alertMessage: any
        if (isLocationExist) {
            alertMessage = "This location is already added, please select another location or add new location"
        } else if (isPrimaryLocationAlert) {
            alertMessage = "Primary location is already selected for an existing location. Do you wish to proceed to mark this location primary and remove primary from the existing location?";
        }
        else {
            alertMessage = "This location is already added, please select another location or add new location?"
        }

        let dialogRef = this.dialog.open(W9AlertComponent, {
            disableClose: true,
            data: { message: alertMessage, isPrimaryLocationAlert: isPrimaryLocationAlert },
            width: '550px',
            backdropClass: '',
            hasBackdrop: true,
        });
        dialogRef.afterClosed().subscribe((result: any) => {
            if (result == true && !isLocationExist && !isPrimaryLocationAlert) {
                localStorage.setItem("isW9Alert", "true")
                this.router.navigate(['/credentialing/locations/add-tin'])
            } else if (result == true && isPrimaryLocationAlert) {
                this.primaryLocationFormGroup.get('isPrimary')?.setValue('yes');
            }
        });
    }

    isLocationAlreadyExists(selectedRecord: any) {
        const existingLocations = JSON.parse(localStorage.getItem("locations") || "[]");
        return existingLocations.some((loc: any) => loc.esLocationId === selectedRecord?.esLocationId);
    }

    private hasIncompletePayeeAddressForCorpAuth(): boolean {
        if (!this.showTinAndPayeeSections) {
            return false;
        }

        const payeeFormGroup = this.createTinComponent?.payeeFormGroup;
        if (!payeeFormGroup) {
            return false;
        }

        const payeeAddressControls = ['payeeLocation', 'payeeCity', 'payeeState', 'payeeZip'];
        return payeeAddressControls.some((controlName: string) => {
            const control = payeeFormGroup.get(controlName);
            if (!control || control.disabled) {
                return false;
            }

            const value = control.value;
            const isEmpty = value === null || value === undefined || `${value}`.trim() === '';
            return isEmpty || control.invalid;
        });
    }

    isCorpAuthReadAndSignDisabled(): boolean {
        const hasInvalidLocationOrPrimary = !this.locationFormGroup.valid || !this.primaryLocationFormGroup.valid;
        return hasInvalidLocationOrPrimary || this.hasIncompletePayeeAddressForCorpAuth();
    }

    disableAddLocation(): boolean {

        const requiredControls = [
            'tin',
            'name',
            'location',
            'city',
            'state',
            'zip',
            'officeTypeID',
            'voicePhone',
            'email'
        ];
        const rawForm = this.locationFormGroup.getRawValue();
        const hasEmptyRequiredField = requiredControls.some(control => {
            const value = rawForm[control as keyof typeof rawForm];
            return value === null || value === undefined || value === '';
        });
        const hasIncompleteTinAndPayeeSection = this.showTinAndPayeeSections
            ? (!this.createTinComponent || this.createTinComponent.createNeedtoDisable())
            : false;
        return (
            hasEmptyRequiredField ||
            this.hasInvalidLocationSaveState(false) ||
            this.showFulladdressError ||
            this.showStateError ||
            hasIncompleteTinAndPayeeSection
        );
    }

    private hasInvalidLocationSaveState(markAsTouched: boolean): boolean {
        if (markAsTouched) {
            this.locationFormGroup.markAllAsTouched();
            this.primaryLocationFormGroup.markAllAsTouched();
            this.participatingFormGroup.markAllAsTouched();
            this.practiceFormGroup.markAllAsTouched();
        }

        const hasInvalidEnabledLocationControl = Object.keys(this.locationFormGroup.controls).some((key) => {
            const control = this.locationFormGroup.get(key);
            return !!control && control.enabled && control.invalid;
        });

        return hasInvalidEnabledLocationControl || this.primaryLocationFormGroup.invalid;
    }

    private markInvalidLocationFieldsAsTouched(): void {
        const fieldsToMark = ['voicePhone', 'email', 'zip'];
        fieldsToMark.forEach((field: string) => {
            const control = this.locationFormGroup.get(field);
            if (!control || control.disabled) {
                return;
            }

            const value = control.value;
            if ((value === null || value === undefined || `${value}`.trim() === '') || !control.invalid) {
                return;
            }

            control.markAsTouched();
        });
    }

    preparePayload(formData: any, eventId: any) {
        const resolvedLocationId = this.editLocationId ? (this.selectedItem?.locationId ?? null) : null;
        const resolvedEsLocationId =
            this.selectedItem?.esLocationId ||
            (this.isLocationFromTinSearch
                ? this.selectedLocationRecordFromTinSearch?.esLocationId
                : null);
        const dwSourceLocation = this.selectedItem || this.selectedLocationRecordFromTinSearch || { esLocationId: resolvedEsLocationId };
        const locationFieldLockState = this.captureLocationFieldLockState();
        const location: any = {
            locationId: resolvedLocationId,
            credentialingEventId: eventId,
            name: formData.name,
            address1: formData.location,
            address2: null,
            city: formData.city,
            state: formData.state,
            zip: formData.zip,
            isLocationFromTINSearch: this.isLocationFromTinSearch,
            tin: formData.tin,
            isPrimary:
                this.primaryLocationFormGroup.get('isPrimary')?.value === 'yes'
                    ? true
                    : this.primaryLocationFormGroup.get('isPrimary')?.value === 'no'
                        ? false
                        : null,
            stillPracticing:
                this.practiceFormGroup.get('isPracticing')?.value === 'yes'
                    ? true
                    : this.practiceFormGroup.get('isPracticing')?.value === 'no'
                        ? false
                        : null,
            endedPracticingAt: formData.endDate
                ? this.formatDate(formData.endDate)
                : null,
            startPracticingAt: formData.startDate
                ? this.formatDate(formData.startDate)
                : null,
            isParticipating:
                (!this.isLocationFromTinSearch && this.practiceFormGroup.get('isPracticing')?.value === 'yes')
                    ? true
                    :(!this.isLocationFromTinSearch && this.practiceFormGroup.get('isPracticing')?.value === 'no')
                        ? false
                        : this.participatingFormGroup.get('isParticipating')?.value === 'yes'
                            ? true
                            : this.participatingFormGroup.get('isParticipating')?.value === 'no'
                                ? false
                                : null,
            esLocationId: resolvedEsLocationId,
            dwVoicePhone: this.resolveDwSourceValue(dwSourceLocation, 'dwVoicePhone', ['locationVoicePhone', 'voicePhone', 'phone']),
            dwEmail: this.resolveDwSourceValue(dwSourceLocation, 'dwEmail', ['email', 'locationEmail']),
            dwOfficeTypeID: this.resolveDwSourceValue(dwSourceLocation, 'dwOfficeTypeID', ['officeTypeID', 'officeTypeId']),
            isExistingTinNewLocationFlow: this.isExistingTINNewLocationFlow || !!this.selectedItem?.isExistingTinNewLocationFlow,
            locationFieldLockState: locationFieldLockState,
            dcaDocumentId: this.documentId,
            officeTypeID: formData.officeTypeID || null,
            voicePhone: formData.voicePhone,
            email: formData.email
        };
        if (location.isPrimary) {
            this.locations = this.locations.map((l: any) => ({ ...l, isPrimary: false }));
        }
        const index = this.locations.findIndex((item: any) =>
            (location.locationId != null && item.locationId == location.locationId) ||
            (location.locationId == null && location.esLocationId != null && item.esLocationId == location.esLocationId)
        );
        if (index === -1) {
            this.locations = [...this.locations, location];
        } else {
            this.locations = this.locations.map((l: any, i: any) =>
                i === index ? { ...l, ...location } : l
            );
        }
        const payload = this.formatData(this.locations, eventId);

        return payload;;
    }

    getAction(): any {
        const el = JSON.parse(localStorage.getItem('dentistInfo') || '{}') || {};
        const credentialingEvent = JSON.parse(localStorage.getItem('credentialingEvent') || '{}');
        const eventStatus = credentialingEvent?.eventStatus;

        if (!el?.reCredentialDate) {
            return false;
        }
        const recredDate: Date = this.parseYyyyMmDd("" + el.reCredentialDate);

        if (!recredDate) {
            return false;
        }
        const locations = JSON.parse(localStorage.getItem('whLocations') || '[]');
        const isNonPar =
            locations.length > 0 &&
            locations.every(
                (loc: any) =>
                    loc?.providerNetwork?.toLowerCase() === 'not participating'
            );
        if (isNonPar) {
            return false;
        }
        const today = new Date();
        const dueDate = new Date(recredDate);
        const value = Number(this.sharedService.credentialing_graceperiod);
        const gracePeriod = !value || isNaN(value) ? 180 : value;

        dueDate.setDate(dueDate.getDate() - gracePeriod);

        //  Block only if TOO EARLY (more than 180 days before)
        if (today < dueDate) {
            return false;
        }

        return true;
    }

    parseYyyyMmDd(dateString: string): Date {
        const year = Number(dateString.substring(0, 4));
        const month = Number(dateString.substring(4, 6)) - 1;
        const day = Number(dateString.substring(6, 8));

        return new Date(year, month, day);
    }

    isLocationChanged(existingLocation: any, newLocation: any): boolean {
        const isPrimary = this.getBooleanValue(this.primaryLocationFormGroup.get('isPrimary')?.value);
        const isPracticing = this.getBooleanValue(this.practiceFormGroup.get('isPracticing')?.value);
        const isParticipating = this.getBooleanValue(this.participatingFormGroup.get('isParticipating')?.value);
        const isServiceLocationChecked = this.ServiceCheckForm.get('serviceLocationChecked')?.value === true ? true : false;
        const normalizedCurrentStartDate = this.normalizeDateForComparison(newLocation?.startDate);
        const normalizedCurrentEndDate = this.normalizeDateForComparison(newLocation?.endDate);
        const beforeSignedData = this.beforeCorpAuthSignedData;
        if (beforeSignedData) {
            const baselineIsPrimary = this.getBooleanValue(beforeSignedData.isPrimary);
            const baselineIsPracticing = this.getBooleanValue(beforeSignedData.stillPracticing ?? beforeSignedData.isPracticing);
            const baselineIsParticipating = this.getBooleanValue(beforeSignedData.isParticipating);
            const baselineStartDate = this.normalizeDateForComparison(beforeSignedData.startPracticingAt ?? beforeSignedData.startDate);
            const baselineEndDate = this.normalizeDateForComparison(beforeSignedData.endedPracticingAt ?? beforeSignedData.endDate ?? beforeSignedData.endedDate);
            const baselineServiceLocationChecked = beforeSignedData.serviceLocationChecked === true;
            const updated = this.beforeCorpAuthSignedData ? (
                beforeSignedData.name !== (newLocation.name || null) ||
                (beforeSignedData.location || beforeSignedData.address1 || beforeSignedData.address || null) !== (newLocation.location || null) ||
                beforeSignedData.city !== (newLocation.city || null) ||
                beforeSignedData.state !== (newLocation.state || null) ||
                beforeSignedData.zip !== (newLocation.zip || null) ||
                (beforeSignedData.tin || beforeSignedData.taxId || null) !== (newLocation.tin || null) ||
                beforeSignedData.voicePhone !== (newLocation.voicePhone || null) ||
                baselineIsPrimary !== isPrimary ||
                baselineIsPracticing !== isPracticing ||
                baselineStartDate !== normalizedCurrentStartDate ||
                baselineEndDate !== normalizedCurrentEndDate ||
                baselineIsParticipating !== isParticipating ||
                baselineServiceLocationChecked !== isServiceLocationChecked
            ) : false
            return updated;
        }
        if (!this.editLocationId) {
            return false;
        }
        const normalizedExistingStartDate = this.normalizeDateForComparison(existingLocation?.startPracticingAt ?? existingLocation?.startDate);
        const normalizedExistingEndDate = this.normalizeDateForComparison(existingLocation?.endedPracticingAt ?? existingLocation?.endDate ?? existingLocation?.endedDate);
        const changed = existingLocation
            ? (
                (existingLocation?.name !== (newLocation.name || null)) ||
                ((existingLocation?.address || existingLocation?.address1 || existingLocation?.location) !== (newLocation.location || null)) ||
                (existingLocation?.city !== (newLocation.city || null)) ||
                (existingLocation?.state !== (newLocation.state || null)) ||
                (existingLocation?.zip !== (newLocation.zip || null)) ||
                (existingLocation?.tin !== (newLocation.tin || null)) ||
                (existingLocation?.voicePhone !== (newLocation.voicePhone || null)) ||
                (existingLocation?.isPrimary !== isPrimary) ||
                (normalizedExistingStartDate !== normalizedCurrentStartDate) ||
                (normalizedExistingEndDate !== normalizedCurrentEndDate) ||
                (existingLocation?.isParticipating !== isParticipating)
            )
            : false;
        return changed;
    }
    private getBooleanValue(value: any): boolean | null {
        if (value === true || value === 'yes' || value === 'true' || value === 1 || value === '1') {
            return true;
        }
        if (value === false || value === 'no' || value === 'false' || value === 0 || value === '0') {
            return false;
        }
        return null;
    }
    private normalizeDateForComparison(value: any): string | null {
        if (!value) {
            return null;
        }
        const formatted = this.formatDate(value);
        return formatted ? formatted : null;
    }

    private normalizeTinIdentifier(value: any): string {
        if (value === undefined || value === null) {
            return '';
        }
        const normalizedValue = `${value}`.trim();
        if (!normalizedValue) {
            return '';
        }
        const digitsOnly = normalizedValue.replace(/[^0-9]/g, '');
        return digitsOnly || normalizedValue;
    }

    private isSameTinIdentifier(left: any, right: any): boolean {
        const normalizedLeft = this.normalizeTinIdentifier(left);
        const normalizedRight = this.normalizeTinIdentifier(right);
        return !!normalizedLeft && !!normalizedRight && normalizedLeft === normalizedRight;
    }

    private normalizeCorpAuthComparableValue(value: any): string | null {
        if (value === undefined || value === null) {
            return null;
        }
        const normalizedValue = `${value}`.trim();
        return normalizedValue === '' ? null : normalizedValue;
    }

    private normalizePhoneForCompare(value: any): string | null {
        if (value === undefined || value === null) {
            return null;
        }
        const digits = `${value}`.replace(/[^0-9]/g, '').trim();
        return digits === '' ? null : digits;
    }

    private normalizeBooleanForCompare(value: any): boolean | null {
        if (value === undefined || value === null || value === '') {
            return null;
        }
        if (value === true || value === false) {
            return value;
        }
        if (value === 1 || value === '1' || value === 'yes' || value === 'true') {
            return true;
        }
        if (value === 0 || value === '0' || value === 'no' || value === 'false') {
            return false;
        }
        return null;
    }

    private normalizeNullableBooleanWithFalseDefault(value: any): boolean {
        const normalized = this.normalizeBooleanForCompare(value);
        return normalized === null ? false : normalized;
    }

    private normalizeIntegerForCompare(value: any): number | null {
        if (value === undefined || value === null || value === '') {
            return null;
        }
        const parsed = Number.parseInt(`${value}`, 10);
        return Number.isNaN(parsed) ? null : parsed;
    }

    private isApiComparableLocationChanged(existingLocation: any): boolean {
        if (!existingLocation || !this.editLocationId) {
            return false;
        }

        const formData = this.locationFormGroup.getRawValue();
        const currentPracticing = this.getBooleanValue(this.practiceFormGroup.get('isPracticing')?.value);
        const currentParticipating = this.getBooleanValue(this.participatingFormGroup.get('isParticipating')?.value);
        const currentStartDate = this.normalizeDateForComparison(formData?.startDate);
        const currentEndDate = this.normalizeDateForComparison(formData?.endDate);

        const existingStartDate = this.normalizeDateForComparison(existingLocation?.startPracticingAt ?? existingLocation?.startDate);
        const existingEndDate = this.normalizeDateForComparison(existingLocation?.endedPracticingAt ?? existingLocation?.endDate ?? existingLocation?.endedDate);

        return (
            this.normalizeCorpAuthComparableValue(existingLocation?.name) !== this.normalizeCorpAuthComparableValue(formData?.name) ||
            this.normalizeCorpAuthComparableValue(existingLocation?.address1 ?? existingLocation?.address ?? existingLocation?.location) !== this.normalizeCorpAuthComparableValue(formData?.location) ||
            this.normalizeCorpAuthComparableValue(existingLocation?.city) !== this.normalizeCorpAuthComparableValue(formData?.city) ||
            this.normalizeCorpAuthComparableValue(existingLocation?.state) !== this.normalizeCorpAuthComparableValue(formData?.state) ||
            this.normalizeCorpAuthComparableValue(existingLocation?.zip) !== this.normalizeCorpAuthComparableValue(formData?.zip) ||
            this.normalizeTinIdentifier(existingLocation?.tin) !== this.normalizeTinIdentifier(formData?.tin) ||
            this.normalizePhoneForCompare(existingLocation?.voicePhone) !== this.normalizePhoneForCompare(formData?.voicePhone) ||
            this.normalizeBooleanForCompare(existingLocation?.stillPracticing) !== currentPracticing ||
            existingStartDate !== currentStartDate ||
            existingEndDate !== currentEndDate ||
            this.normalizeBooleanForCompare(existingLocation?.isParticipating) !== currentParticipating ||
            this.normalizeNullableBooleanWithFalseDefault(existingLocation?.isLocationFromTINSearch) !== this.normalizeNullableBooleanWithFalseDefault(this.isLocationFromTinSearch)
        );
    }

    private buildCurrentCorpAuthComparableData(): any {
        const locationData = this.locationFormGroup.getRawValue();
        const payeeData: Record<string, any> = this.createTinComponent?.payeeFormGroup?.getRawValue?.() || {};
        return {
            name: locationData?.name ?? null,
            location: locationData?.location ?? null,
            city: locationData?.city ?? null,
            state: locationData?.state ?? null,
            zip: locationData?.zip ?? null,
            payeeName: payeeData?.['payeeName'] ?? null,
            payeeAddressLine1: payeeData?.['payeeLocation'] ?? null,
            payeeAddressLine2: payeeData?.['payeeAddress2'] ?? null,
            payeeCity: payeeData?.['payeeCity'] ?? null,
            payeeState: payeeData?.['payeeState'] ?? null,
            payeeZip: payeeData?.['payeeZip'] ?? null
        };
    }

    private isCorpAuthSensitiveLocationChange(): boolean {
        if (!this.beforeCorpAuthSignedData || Object.keys(this.beforeCorpAuthSignedData).length === 0) {
            return false;
        }

        const baseline: Record<string, any> = this.beforeCorpAuthSignedData as Record<string, any>;
        const current: Record<string, any> = this.buildCurrentCorpAuthComparableData();
        const valueChanged = (left: any, right: any) => this.normalizeCorpAuthComparableValue(left) !== this.normalizeCorpAuthComparableValue(right);
        const hasSignedPayeeSnapshot = baseline['hasPayeeSnapshot'] === true;
        const baseLocationChanged = valueChanged(baseline['name'], current['name']) ||
            valueChanged(baseline['location'] ?? baseline['address1'] ?? baseline['address'], current['location']) ||
            valueChanged(baseline['city'], current['city']) ||
            valueChanged(baseline['state'], current['state']) ||
            valueChanged(baseline['zip'], current['zip']);
        if (baseLocationChanged) {
            return true;
        }
        if (!hasSignedPayeeSnapshot) {
            return false;
        }
        return valueChanged(baseline['payeeName'], current['payeeName']) ||
            valueChanged(baseline['payeeAddressLine1'] ?? baseline['payeeAddress1'], current['payeeAddressLine1']) ||
            valueChanged(baseline['payeeAddressLine2'] ?? baseline['payeeAddress2'], current['payeeAddressLine2']) ||
            valueChanged(baseline['payeeCity'], current['payeeCity']) ||
            valueChanged(baseline['payeeState'], current['payeeState']) ||
            valueChanged(baseline['payeeZip'], current['payeeZip']);
    }

    private isCorpAuthSensitivePayeeChange(): boolean {
        if (!this.createTinComponent?.payeeFormGroup) {
            return false;
        }
        const baselinePayeeData =
            this.createTinComponent.beforeFormData ||
            this.createTinComponent.TINdata ||
            this.beforeCorpAuthSignedData;
        if (!baselinePayeeData) {
            return false;
        }
        const payeeData = this.createTinComponent.payeeFormGroup.getRawValue();
        const currentPayeePayload = {
            payeeName: payeeData?.payeeName,
            payeeAddressLine1: payeeData?.payeeLocation,
            payeeAddressLine2: payeeData?.payeeAddress2,
            payeeCity: payeeData?.payeeCity,
            payeeState: payeeData?.payeeState,
            payeeZip: payeeData?.payeeZip
        };
        return this.createTinComponent.ValdiatePayeeAddress(baselinePayeeData, currentPayeePayload);
    }

    isCorpAuthRequierd() {
        return (!this.isWhLocation && !this.isLocationFromTinSearch && this.participatingFormGroup.get('isParticipating')?.value == 'yes')
            || (!this.isPar && this.participatingFormGroup.get('isParticipating')?.value == 'yes')
            || (this.isLocationFromTinSearch && this.participatingFormGroup.get('isParticipating')?.value == 'yes');
    }

    deleteDocument(fileName: any, subCategoryId: any, documentId?: any) {
        const loginUserId = localStorage.getItem("loggedUserId");
        const credentialingEventId = localStorage.getItem('credentialingEventId');
        if (`${subCategoryId}` === `${DocumentSubCategory.CorporateAuthorityForm}`) {
            const documents = JSON.parse(localStorage.getItem('documents') || '[]');
            const documentIndex = documents.findIndex(
                (item: any) => {
                    const itemSubCategoryId = item?.subCategoryId ?? item?.subCategoryID ?? item?.SubCategoryID;
                    return `${itemSubCategoryId}` === `${subCategoryId}` &&
                    (
                        (documentId != null && item.documentId == documentId) ||
                        item.fileName === fileName
                    );
                }
            );
            if (documentIndex !== -1) {
                documents.splice(documentIndex, 1);
                localStorage.setItem('documents', JSON.stringify(documents));
            }
            const activeEditId = this.editLocationId ?? localStorage.getItem('editLocationId');
            const locations = JSON.parse(localStorage.getItem('locations') || '[]');
            if (Array.isArray(locations)) {
                const updatedLocations = locations.map((location: any) => {
                    const locationDocumentId = location?.dcaDocumentId ?? location?.dcaDocumentID;
                    const matchesDeletedDocument = `${locationDocumentId ?? ''}` === `${documentId ?? ''}`;
                    const matchesActiveLocation =
                        activeEditId != null &&
                        (
                            `${location?.locationId ?? ''}` === `${activeEditId}` ||
                            `${location?.esLocationId ?? ''}` === `${activeEditId}`
                        );
                    return (matchesDeletedDocument || matchesActiveLocation)
                        ? { ...location, dcaDocumentId: null, isCorpAuthResignRequired: true }
                        : location;
                });
                localStorage.setItem('locations', JSON.stringify(updatedLocations));
            }
            this.corporateAuthSigned = false;
            this.documentsMap = null;
            this.documentId = null;
        }
        const requestParams = {
            "credentialingEventID": Number(credentialingEventId),
            "fileName": fileName,
            "modifiedUserID": loginUserId ? Number(loginUserId) : 0
        }
        this.dentalCredentialingService.deleteDocument(requestParams).subscribe({
            next: (response: any) => {
                const updatedDocuments = JSON.parse(localStorage.getItem('documents') || '[]');
                const _index = updatedDocuments.findIndex(
                    (item: any) => {
                        const itemSubCategoryId = item?.subCategoryId ?? item?.subCategoryID ?? item?.SubCategoryID;
                        return `${itemSubCategoryId}` === `${subCategoryId}` &&
                        (
                            (documentId != null && item.documentId == documentId) ||
                            item.fileName === fileName
                        );
                    }
                );

                if (_index !== -1) {
                    updatedDocuments.splice(_index, 1);
                }
                localStorage.setItem('documents', JSON.stringify(updatedDocuments));
                if (subCategoryId === DocumentSubCategory.CorporateAuthorityForm) {
                    const locations = JSON.parse(localStorage.getItem('locations') || '[]');
                    if (Array.isArray(locations)) {
                        const updatedLocations = locations.map((location: any) =>
                            `${location?.dcaDocumentId ?? location?.dcaDocumentID ?? ''}` === `${documentId ?? ''}`
                                ? { ...location, dcaDocumentId: null, isCorpAuthResignRequired: true }
                                : location
                        );
                        localStorage.setItem('locations', JSON.stringify(updatedLocations));
                    }
                }
            }, error: (err: any) => {
            }
        })
    }

    get filteredStateOptions(): SelectOption[] {
        return this.stateOptions.filter(opt => this.allowedStates.includes(opt.value));
    }
    get stateRestrictionMessage(): string {
        if (this.allowedStates.length === 1) {
            const stateName = this.allowedStates[0] === 'MO' ? 'Missouri (MO)' : 'South Carolina (SC)';
            return `Only ${stateName} locations are allowed`;
        }
        return 'Only Missouri (MO) and South Carolina (SC) locations are allowed';
    }
    restrictNonNumeric(event: KeyboardEvent): void {
        this.sharedService.preventNonNumeric(event);
    }
    restrictNonNumericPaste(event: ClipboardEvent): void {
        this.sharedService.preventNonNumbericForPaste(event);
    }
}
